import { secureGet, securePost } from '../utils/HttpUtils';

const apiUrls = {
  quotations: '/v1/private/applications/quotations',
  quotationsByAssetCode: (assetCode: string) => `/v1/private/applications/quotations/${assetCode}`,
};

export interface Quotation {
  id: number;
  name: string;
  code: string;
  updatedAt: string | null;
  purchaseValue: number | string;
  saleValue: number | string;
}

export interface QuotationListItem {
  updatedAt: string | null;
  purchaseValue: number | null;
  saleValue: number | null;
}

export interface QuotationsPage {
  content: QuotationListItem[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export const getQuotations = async () => {
  try {
    const response = await secureGet(apiUrls.quotations);
    return response;
  } catch (error) {
    console.error('Error fetching quotations:', JSON.stringify(error, null, 2));
    throw error;
  }
};

export const getAssetByCode = async (code: string): Promise<Quotation | null> => {
  try {
    const response = await getQuotations();
    if (response?.data && Array.isArray(response.data)) {
      const asset = response.data.find((q: Quotation) => q.code === code);
      return asset || null;
    }
    return null;
  } catch (error) {
    console.error('Error fetching asset by code:', JSON.stringify(error, null, 2));
    return null;
  }
};

export const getQuotationsByAssetCode = async (
  assetCode: string,
  page: number = 0,
  size: number = 10
) => {
  try {
    const url = `${apiUrls.quotationsByAssetCode(assetCode)}?page=${page}&size=${size}`;
    const response = await secureGet(url);
    return response;
  } catch (error) {
    console.error('Error fetching quotations by asset code:', JSON.stringify(error, null, 2));
    throw error;
  }
};

export const createQuotation = async (
  assetCode: string,
  quotationData: {
    updatedAt?: string;
    purchaseValue: number;
    saleValue: number;
    isChargedAutomatically?: boolean;
  }
) => {
  try {
    const url = apiUrls.quotationsByAssetCode(assetCode);
    const response = await securePost(url, quotationData);
    return response;
  } catch (error) {
    console.error('Error creating quotation:', JSON.stringify(error, null, 2));
    throw error;
  }
};
